import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import config from "../config";
function BoardReports() {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedReport, setSelectedReport] = useState("");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const menuToggle = document.getElementById("sidebar-hide");
        const sidebar = document.querySelector(".pc-sidebar");
        if (!menuToggle) return;

        const toggleSidebar = () => {
            sidebar.classList.toggle("pc-sidebar-hide");
        };

        menuToggle.addEventListener("click", toggleSidebar);

        return () => {
            menuToggle.removeEventListener("click", toggleSidebar);
        };
    }, [location.pathname]);
    // API Endpoints mapping
    const reportEndpoints = {
        "Pending For Challan Generation": `${config.API_BASE_URL}/auth/CentreWisePendingChallanDetails`,
        "Challan Pending at board Approval": `${config.API_BASE_URL}/auth/CenterWiseAllPendingChallanApprove`,
        "Approved Challan": `${config.API_BASE_URL}/auth/CentreWiseAllApprovedChallan`,
        "Rejected Challan": `${config.API_BASE_URL}/auth/CentreWiseAllRejectedChallan`,
        "Total Challan Generation Report": `${config.API_BASE_URL}/auth/CentreWiseTotalChallanDetails`,
        "Centre Wise Details Status Report": `${config.API_BASE_URL}/auth/CentreWiseDetailsStatusReport`
    };

    // Handle dropdown change
    const handleReportChange = (e) => {
        setSelectedReport(e.target.value);
    };

    const fetchReportData = async () => {
        if (!selectedReport || selectedReport === "Select") {
            Swal.fire("Please select a report type.", "", "warning");
            return;
        }

        const token = localStorage.getItem("token2");
        if (!token) {
            Swal.fire("Authentication Error", "Token is missing. Please log in.", "error");
            return;
        }

        try {
            setLoading(true);
            const response = await axios.get(reportEndpoints[selectedReport], {
                headers: { Authorization: `Bearer ${token}` }
            });

            let extractedData = [];

            // Extract data based on API response structure
            switch (selectedReport) {
                case "Pending For Challan Generation":
                    extractedData = response.data.data.pending_challans;
                    break;
                case "Challan Pending at board Approval":
                    extractedData = response.data.data.pending_challans;
                    break;
                case "Approved Challan":
                    extractedData = response.data.data.approved_challans;
                    break;
                case "Rejected Challan":
                    extractedData = response.data.data.rejected_challans;
                    break;
                case "Total Challan Generation Report":
                    extractedData = response.data.data.center_details;
                    break;
                case "Centre Wise Details Status Report":
                    extractedData = response.data.data.center_details;
                    break;
                default:
                    extractedData = [];
                    break;
            }

            setReportData(extractedData);
            console.log(extractedData);
            setLoading(false);
            Swal.fire("Success", "Data fetched successfully!", "success");

            // Automatically generate and download Excel after fetching data
            generateExcel(extractedData);

        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
            Swal.fire("Data not found.", "", "warning");
        }
    };


    const generateExcel = (data = reportData) => {
        if (!data.length) {
            Swal.fire("No Data", "No data available for export.", "warning");
            return;
        }

        try {
            // Extract headers dynamically and add "Sl. No." at the beginning
            const headers = ["Sl. No.", ...Object.keys(data[0])];

            // Prepare Excel worksheet with a title row and headers
            const ws = XLSX.utils.aoa_to_sheet([
                [`Report: ${selectedReport}`], // Report title
                [], // Empty row for spacing
                headers.map(header => header.replace(/_/g, " ")) // Column headers with formatted names
            ]);

            // Map data rows with serial numbers
            // Map data rows with serial numbers
            const rows = data.map((row, index) => [
                index + 1, // Serial Number (starting from 1)
                ...Object.keys(row).map(header =>
                    row[header] !== null && row[header] !== undefined ? row[header] : ""
                )
            ]);


            // Add data rows to the sheet
            XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

            // Merge the title row across all columns
            ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];

            // Adjust column widths dynamically
            ws["!cols"] = headers.map(() => ({ wch: 25 }));

            // Create Excel workbook and append the sheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Report");

            // Generate filename and download file
            const fileName = `Report_${selectedReport.replace(/ /g, "_")}.xlsx`;
            XLSX.writeFile(wb, fileName);

            Swal.fire("Success", "Excel file has been downloaded successfully!", "success");

        } catch (error) {
            console.error("Error generating Excel:", error);
            Swal.fire("Error", "An error occurred while generating the Excel file.", "error");
        }
    };



    const movetodashboard = (e) => {
        e.preventDefault();
        navigate("/Board-dashboard");
    };

    return (
        <div>
            <Navbar />
            <Header />
            <div className="pc-container">
                {loading && (
                    <div className="custom-loader-container">
                        <div className="custom-loader"></div>
                    </div>
                )}
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12 breadcrumb">
                                    <div className="page-header-title">
                                        <h5 className="m-b-10">Reports</h5>
                                    </div>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="" onClick={movetodashboard}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item"><a href="">Reports</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ padding: '0px' }}>
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="form-label">Select Report Type</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={selectedReport}
                                                    onChange={handleReportChange}
                                                >
                                                    <option>Select</option>
                                                    {Object.keys(reportEndpoints).map((report) => (
                                                        <option key={report} value={report}>
                                                            {report}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                <label className="form-label">&nbsp;</label><br />
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm custom-padding"
                                                    onClick={fetchReportData}
                                                >
                                                    <i className="fa fa-download"></i>&nbsp;&nbsp;Download Report
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default BoardReports;
